module.exports = __webpack_public_path__ + "img/magento-security-services@2x.2c48c0a9.jpeg";